module.exports = __webpack_public_path__ + "fonts/500-italic-cyrillic-ext.fc1de33.woff2";